import React, { useEffect, useState } from 'react'
import { eye_icon, left_arrow } from '../../assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';

const CancelledView = () => {
    const [visible, setVisible] = useState(false);
    const navigate = useNavigate()
    const location = useLocation()
    const bookingData = location?.state?.bookingData;
    const [adult, setAdult] = useState();
    const [child, setChild] = useState();
    const [blockDates, setBlockDates] = useState();
    const [blockToDates, setBlockToDates] = useState();

    useEffect(() => {
        setChild(bookingData?.booking_rooms?.map((item) => {
            return (
                item?.no_of_childs
            )
        }))
        setAdult(bookingData?.booking_rooms?.map((item) => {
            return (
                item?.no_of_adults
            )
        }))
        setBlockDates(bookingData?.from_date)
        setBlockToDates(bookingData?.to_date)
    }, [])

    console.log('datum', bookingData)

    return (
        <div className="dashRightView home_section">
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
                    Bookings - Cancelled
                </h2>
            </div>

            <div className='d-flex ac-js gap-2'
                onClick={() => navigate(-1)}
            >
                <img src={left_arrow} className='leftArrow mb-3' />
                <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">Back</p>
            </div>

            <div className="">
                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Property Name
                        </h4>
                        <input type="text" value={bookingData?.property?.name} disabled className="input-pop ps-2 w-100" placeholder="Property Name" />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Owner Name
                        </h4>
                        <input type="text" value={bookingData?.property?.owner?.name} disabled className="input-pop ps-2 w-100" placeholder="Owner Name" />
                    </div>

                </div>

                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            User Name
                        </h4>
                        <input type="text" value={bookingData?.user?.name} disabled className="input-pop ps-2 w-100" placeholder="Owner Name" />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Pricing
                        </h4>
                        <input type="text" value={bookingData?.total_amount} disabled className="input-pop ps-2 w-100" placeholder="Pricing" />
                    </div>

                </div>

                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Date
                        </h4>
                        <input type="text" value={bookingData?.user?.name} disabled className="input-pop ps-2 w-100" placeholder="Date" />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Booking ID
                        </h4>
                        <input type="text" value={bookingData?.booking_id} disabled className="input-pop ps-2 w-100" placeholder="Booking ID" />
                    </div>

                </div>

                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Booked ON
                        </h4>
                        <input type="text" value={moment(bookingData?.created_at).format("DD-MM-YYYY")} disabled className="input-pop ps-2 w-100" placeholder="Booked ON" />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Room Type
                        </h4>
                        <input type="text" value={bookingData?.room_category?.name} className="input-pop ps-2 w-100" placeholder="Room Type" />
                    </div>

                </div>

                <div className='d-flex gap-5 mb-4'>

                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            persons
                        </h4>
                        <div className='d-flex gap-3'>
                            <div className="w-50 d-flex ac-js gap-2" >
                                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  primary1">  Adults</h4>
                                <input type="text" value={bookingData?.total_adults} className="input-pop ps-2 w-100" placeholder="Adult : 10" />
                            </div>
                            <div className="w-50 d-flex ac-js gap-2">
                                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">  Childs</h4>
                                <input type="text" value={bookingData?.total_childs} className="input-pop ps-2 w-100" placeholder="Children : 10" />
                            </div>
                        </div>

                    </div>
                </div>
                <div className='d-flex gap-5 mb-4'>

                    <div className='col-md-7'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Cancellation
                        </h4>
                        <div className='input-pop ps-2 w-100 h-100'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 red">
                                Cancelled By
                            </h4>
                            <p className="cust-btn ps-2 w-100 " placeholder="Reason For Cancel" >{bookingData?.cancelled_by ? bookingData?.cancelled_by?.name : "Null"}</p>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 red">
                                Reason
                            </h4>
                            <p value={bookingData?.cancel_reason ? bookingData?.cancel_reason : "Null"} disabled className="cust-btn ps-2 w-100 " placeholder="Reason For Cancel" >{bookingData?.cancel_reason ? bookingData?.cancel_reason : "Null"}</p>

                            {/* <p  value={bookingData?.} disabled className="cust-btn ps-2 w-100 " placeholder="Reason For Cancel" >{bookingData?.}</p> */}
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default CancelledView